import React from "react";
import Slider from "react-slick";
import {
  Box,
  Container,
  Typography,
  Button,
  Stack
} from "@mui/material";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import LoginTimeWidget from "./LoginTimeWidget";
import i18n from '../../i18n/i18n';

const slides = [
  {
    get title() { return i18n.t('auth.feesManagement'); },
    get description() { return i18n.t('auth.handleFeeStructuresCollectionsRemindersAnd'); },
    image: "/assets/images/parentdash/s5.png"
  },
  {
    get title() { return i18n.t('auth.classesTimetable'); },
    get description() { return i18n.t('auth.organizeClassesSectionsSubjectsAndGenerate'); },
    image: "/assets/images/parentdash/s4.png"
  },
  {
    get title() { return i18n.t('auth.attendanceSystem'); },
    get description() { return i18n.t('auth.monitorRealTimeStudentAndStaff'); },
    image: "/assets/images/parentdash/s6.png"
  }
];

export default function FeatureSlider() {
  const settings = {
    dots: true,
    infinite: true,
    autoplay: true,        
    autoplaySpeed: 3000, 
    speed: 600,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false
  };

  return (
    <Box
       sx={{
        width: "100%",
        position: "relative",
"& .slick-dots": {
  bottom: "-30px",
  display: "flex !important",
  justifyContent: "center",
  alignItems: "center",
  gap: "8px",              
  padding: 0,
  margin: 0
},

"& .slick-dots li": {
  width: "auto",
  margin: 0               
},

"& .slick-dots li button": {
  padding: 0
},

"& .slick-dots li button:before": {
  content: '""',
  display: "block",
  width: "8px",
  height: "8px",
  borderRadius: "50px",
  backgroundColor: "#d1d5db",
  opacity: 1,
  transition: "all 0.4s cubic-bezier(0.4,0,0.2,1)"
},

"& .slick-dots li.slick-active button:before": {
  width: "28px",
  backgroundColor: "#8f01ff",
  borderRadius: "20px"
}
      }}
    >
    <LoginTimeWidget />
      <Container maxWidth="sm">
        <Slider {...settings}>
          {slides.map((slide, index) => (
            <Box key={index}>
              <Stack
                spacing={0}
                alignItems="center"
                textAlign="center"
              >
                <Box
                  component="img"
                  src={slide.image}
                  alt={slide.title}
                  sx={{
                    width: "100%",
                    maxWidth: { xs: "200px", sm: "250px", md: "150px", lg: "150px", xl: "250px" },
                  }}
                />

                <Typography variant="h4" fontWeight={600} mb={{ xs: 1, sm: 1, md: 0.5, lg: 0.5, xl: 3 }} sx={{fontSize:{ xs: 18, sm: 18, md: 20, lg: 20, xl: 24 }}}>
                  {slide.title}
                </Typography>

                <Typography variant="body1" color="rgba(0, 0, 0, 0.6)" mb={{ xs: 1, sm: 1, md: 0.5, lg: 0.5, xl: 1 }}>
                  {slide.description}
                </Typography>
              </Stack>
            </Box>
          ))}
        </Slider>
      </Container>
    </Box>
  );
}